module.exports = __webpack_public_path__ + "img/hacker-fill.5d1b5bb2.svg";